// react
import { useState } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';

// material ui
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

const ResetSubscription = ({ open, onClose, handleResetSubscription }) => {
  const { t } = useTranslation();
  const [resetOptions, setResetOptions] = useState({
    reset_predictive_occupancy_detection: true,
    reset_preheat: false,
    reset_cooldown: false,
  });

  const handleToggle = (key) => (event) => {
    setResetOptions((prev) => ({
      ...prev,
      [key]: event.target.checked,
    }));
  };

  const handleConfirm = () => {
    handleResetSubscription(resetOptions);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('actions.confirm')}</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          {t('subscriptionDialogs.resetConfirmation', {
            ns: 'buildingOptimization',
          })}
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_predictive_occupancy_detection}
                onChange={handleToggle('reset_predictive_occupancy_detection')}
              />
            }
            label="Reset predictive occupancy detection"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_preheat}
                onChange={handleToggle('reset_preheat')}
              />
            }
            label="Reset preheat model"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={resetOptions.reset_cooldown}
                onChange={handleToggle('reset_cooldown')}
              />
            }
            label="Reset cooldown model"
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          {t('actions.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          startIcon={<RestoreRoundedIcon />}
          variant="contained"
          color="warning"
        >
          {t('actions.reset')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetSubscription;
